function LogoIcon({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="11" fill="#5B3CE4"/>
      <rect x="6" y="8" width="9" height="20" rx="2" fill="white" fillOpacity="0.8"/>
      <rect x="21" y="8" width="9" height="20" rx="2" fill="white" fillOpacity="0.8"/>
      <rect x="14.5" y="6" width="7" height="24" rx="2.5" fill="white"/>
    </svg>
  );
}

const SIZES = {
  sm: { icon: 26, text: 'text-[13px]', sub: 'text-[8px]', gap: 'gap-[7px]' },
  md: { icon: 32, text: 'text-[15px]', sub: 'text-[10px]', gap: 'gap-[8px]' },
  lg: { icon: 40, text: 'text-[18px]', sub: 'text-[11px]', gap: 'gap-[10px]' },
};

function Logo({ variant = 'default', size = 'md' }) {
  const s = SIZES[size] || SIZES.md;

  if (variant === 'icon') return <LogoIcon size={s.icon} />;

  const textCls = variant === 'white' ? 'text-white'       : 'text-ink';
  const subCls  = variant === 'white' ? 'text-white/65'    : 'text-brand';

  return (
    <div className={`inline-flex items-center ${s.gap}`}>
      <LogoIcon size={s.icon} />
      <div className="flex flex-col leading-none">
        <span className={`font-bold tracking-[-0.3px] leading-[1.1] ${s.text} ${textCls}`}>
          biblioteca
        </span>
        <span className={`font-medium tracking-[3.5px] leading-[1.3] mt-[1px] ${s.sub} ${subCls}`}>
          DE BOLSO
        </span>
      </div>
    </div>
  );
}

export default Logo;
